module.exports = __webpack_public_path__ + "static/paper3-706c50005f9113f848a93d76ed13d794.png";